import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../../ReactQuery/useQuery';
import { get } from '../../../../redux/api';
import type { VcsGitHubMigrationPreviewResponse } from '../../../../../shared/types/routes/internalTools/vcsGitHub';

export const getVcsGitHubMigrationPreviewQueryKey = (): QueryKey =>
  ['internal-tools', 'vcs-github', 'migration-preview'];

function getVcsGitHubMigrationPreview() {
  return get<VcsGitHubMigrationPreviewResponse>('/api/internal-tools/vcs-github/migration-preview');
}

/**
 * Runs a dry run of the current org's backfill on the server and returns the
 * manifest of what a live migration would create and skip. Read-only, but
 * slower than the status query (it derives the plan and reads from
 * vcs-service), so it only runs once explicitly enabled.
 *
 * @param {boolean} enabled - Whether to run the query. Pass `false` until the
 * admin asks for the preview.
 */
export function useGetVcsGitHubMigrationPreview(enabled: boolean) {
  return useQuery<VcsGitHubMigrationPreviewResponse>({
    queryKey: getVcsGitHubMigrationPreviewQueryKey(),
    queryFn: getVcsGitHubMigrationPreview,
    enabled,
  });
}
